// Source
// https://stackoverflow.com/a/57179188/7501646

export const vimeoVideoId = (url: string) => {
  const regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/
  const match = url.match(regExp)
  return match && match[5] ? match[5] : ''
}
